<!-- @format -->
<div class="hmf-mt-m-xxl hmf-mt-xl hmf-grid recommend-container">

    <!-- Certona Recommendations 'Recently Viewed' -->
    <div
        [id]="pageType() !== 'srlp' ? 'family1_rr' : ''"
        class="hmf-col hmf-span-12"
        [class.product-cross-sells-1]="pageType() !== 'srlp'">
        <shared-components-product-recommendations
            displayName="Recently Viewed"
            [filterBy]="pageType() !== 'srlp' ? 'family1_rr' : 'search_rr'"
            [showViewMoreLink]="false"
            [isPLPRecs]="true"
            [showQVButtons]="true"
            [homefieldCarouselEnabled]="true"
			[useSignalRecommendations]="true"
            [pageType]="pageType()"></shared-components-product-recommendations>
    </div>
    <!-- end 'Recently Viewed'-->

    @if (showNoSearchResultsPage()) {
        <div class="hmf-col hmf-span-12">
            <shared-components-product-recommendations
                displayName="You May Also Like"
                filterBy="nosearch_rr"
                [showViewMoreLink]="false"
                [isPLPRecs]="true"
                [homefieldCarouselEnabled]="true"
				[useSignalRecommendations]="true"
                [pageType]="pageType()"></shared-components-product-recommendations>
            <shared-components-product-recommendations
                displayName="Recently Viewed"
                filterBy="nosearch1_rr"
                [showViewMoreLink]="false"
                [isPLPRecs]="true"
                [showQVButtons]="true"
                [homefieldCarouselEnabled]="true"
				[useSignalRecommendations]="true"
                [pageType]="pageType()"></shared-components-product-recommendations>
            <shared-components-product-recommendations
                displayName="Top Categories For You"
                filterBy="contentsearch1_rr"
                [showViewMoreLink]="false"
                [isPLPRecs]="true"
                [homefieldCarouselEnabled]="true"
				[useSignalRecommendations]="true"
                [pageType]="pageType()"></shared-components-product-recommendations>
        </div>
    }

    <!-- Sponsored Products -->
    @if (
        featureFlags().showPLPSponsoredProducts ||
        featureFlags().isUsingCriteoSPAAdServer
    ) {
        <div
            id="contentsearch1_rr"
            class="hmf-col hmf-span-12 product-cross-sells-1">
            @if ((hasSponsoredCarouselProducts())) {
                <shared-components-product-recommendations
                    displayName="Must-Have Picks"
                    [sponsored]="true"
                    [showViewMoreLink]="false"
                    [criteoProducts]="sponsoredCriteoProducts()"
                    [isPLPRecs]="true"
                    [homefieldCarouselEnabled]="true">
                </shared-components-product-recommendations>
            }
        </div>
    }
    <!--end Sponsored Products -->
</div>
